import { SOURCE_VALUES } from "../subscription-contract/index.js";
export const VALID_SOURCE_TYPES = [
    SOURCE_VALUES.WEB,
    SOURCE_VALUES.TM,
    SOURCE_VALUES.SALTO,
    SOURCE_VALUES.CUSTOMER_SERVICE,
];
export const PHONE_REGEX = new RegExp(/^((0047)?|(\+47)?)\d{8}$/);
export const BIRTH_DATE_REGEX = new RegExp(/^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/);
